import { TmrBaseResource } from 'stylewhere/api'

export class Asns extends TmrBaseResource {
  static endpoint = 'api/v1/asns'
}
